import { render } from "./OldCanvasView.vue?vue&type=template&id=4633edd4&scoped=true"
import script from "./OldCanvasView.vue?vue&type=script&lang=js"
export * from "./OldCanvasView.vue?vue&type=script&lang=js"

import "./OldCanvasView.vue?vue&type=style&index=0&id=4633edd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4633edd4"]])

export default __exports__